module.exports = __webpack_public_path__ + "img/txlx_panduantiti.ba6e2efd.png";